import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Grid,
  CircularProgress,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import CustomDialog from "./Dialog";
import searchIcon from "./assets/img/ui-search-icon-round.svg";
import { useLocation, useNavigate } from "react-router-dom";

function Products({
  selectedCategory,
  selectedFilters,
  clearFilters,
  setSelectedCategory = () => {},
}) {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [next, setNext] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [prevCategory, setPrevCategory] = useState("");
  const [prevFilters, setPrevFilters] = useState({});

  const location = useLocation();
  const searchParams = new URLSearchParams(location?.search);
  const keyParam = searchParams.get("key");

  const fetchData = async (setFiltersEmpty = false) => {
    try {
      setLoading("full_page");
      const filters = setFiltersEmpty ? {} : selectedFilters;
      const response = await axios.get(
        `https://bbjlatavola.com/wp-json/products/v1.0/products?filters=${JSON.stringify(
          filters
        )}&page=1&product_cat[]=${selectedCategory}`
      );

      setPrevCategory(response?.data?.prod_cat?.[0] || "");
      setPrevFilters(response?.data?.filters || "");
      setNext(response?.data?.more_pages);
      setProducts(response.data.products);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchScrollData = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://bbjlatavola.com/wp-json/products/v1.0/products?filters=${JSON.stringify(
          selectedFilters
        )}&page=${page}&product_cat[]=${selectedCategory}`
      );

      setPrevCategory(response?.data?.prod_cat?.[0] || "");
      setPrevFilters(response?.data?.filters || "");
      setNext(response?.data?.more_pages);
      setPage(page);

      setProducts((prevProducts) => [
        ...prevProducts,
        ...response.data.products,
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = () => {
    if (
      !loading &&
      next === 1 &&
      window.innerHeight + window.scrollY >= document.body.scrollHeight - 20
    ) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [next, loading]);

  const handleOpenDialog = (product) => {
    setSelectedProduct(product);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleProductClick = (productId) => {
    navigate(`/products/${productId}`);
  };

  // useEffect(() => {
  //   if (page > 1) {
  //     fetchScrollData();
  //   }
  // }, [page]);

  useEffect(() => {
    if (keyParam && setSelectedCategory) {
      setTimeout(() => {
        setSelectedCategory(keyParam);
      }, 1000);
    }
  }, [keyParam, setSelectedCategory]);

  useEffect(() => {
    clearFilters(); // Call clearFilters function when selectedCategory changes
  }, [selectedCategory]);

  useEffect(() => {
    if (typeof selectedFilters === "object") {
      if (Object.keys(selectedFilters).length > 0) {
        fetchData();
      }
    }
  }, [selectedFilters]);

  useEffect(() => {
    if (typeof selectedCategory === "string") {
      fetchData(true);
    }
  }, [selectedCategory]);

  if (loading === "full_page") {
    return (
      <Stack justifyContent={"center"} alignItems={"center"}>
        <CircularProgress />
      </Stack>
    );
  }

  return (
    <>
      {products.length > 0 ? (
        <Grid container spacing={2}>
          {products.map((product, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <div className="product-main">
                <div className="product">
                  <img
                    width="100%"
                    src={product?.featured_image}
                    alt={`Product ${index}`}
                  />
                </div>
                <div className="product-hover">
                  <h2
                    className="title"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleProductClick(product?.post_id)}
                  >
                    {product?.name}
                  </h2>
                  <img
                    style={{ cursor: "pointer" }}
                    src={searchIcon}
                    onClick={() => handleOpenDialog(product)}
                  />
                </div>
              </div>
            </Grid>
          ))}
          <Grid item xs={12}>
            {next > 0 && (
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => fetchScrollData(page + 1)}
                disabled={loading}
                sx={{
                  marginBottom: "20px",
                  backgroundColor: "#333",
                  "&:hover": {
                    backgroundColor: "#333",
                  },
                }}
              >
                {loading ? <CircularProgress size={24} /> : "Load More"}
              </Button>
            )}
          </Grid>
          <CustomDialog
            open={dialogOpen}
            handleClose={handleCloseDialog}
            image={selectedProduct?.featured_image}
            title={selectedProduct?.name}
          />
        </Grid>
      ) : (
        <Stack justifyContent={"center"} alignItems={"center"}>
          <Typography>No Products Found</Typography>
        </Stack>
      )}
    </>
  );
}

export default Products;
